import { Alert as MantineAlert } from "@mantine/core";
import { theme } from "@/theme";
import { Alert as AlertIcon } from "@/components/Icons";
import { PropsWithChildren } from "react";
import classes from "./index.module.css";

interface AlertProps extends PropsWithChildren {
  icon?: React.ReactNode;
  color?: string;
  variant?: string;
  closeButtonLabel?: string;
  onClose?: () => void;
}

// TODO only error variant for now
const Alert = ({ variant = "error", closeButtonLabel, color, icon, onClose, children }: AlertProps) => {
  return (
    <MantineAlert
      variant="filled"
      closeButtonLabel={closeButtonLabel}
      classNames={classes}
      color={color ?? theme.colors?.red?.[3] ?? "red"}
      withCloseButton={!!onClose}
      onClose={onClose}
      icon={icon ?? <AlertIcon width={32} height={32} />}>
      {children}
    </MantineAlert>
  );
};

export default Alert;
